import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 text-left">
            Über SRC Global
          </h2>
          <div className="text-lg text-gray-700 max-w-4xl leading-relaxed text-left space-y-4">
            <p>
              Aus der Entwicklung unseres Geschäftsmodells bei Trees Life International AG ergeben sich verschiedene Aktivitäten, für die wir eigene Unternehmen gegründet haben. Alle unsere Aktivitäten, darunter auch der Anbau von Paulownia auf unseren Plantagen, werden von der Trees Life International AG koordiniert.
            </p>
            <p>
              Bei der Ausarbeitung unserer Nachhaltigkeitsstrategie beschäftigen wir uns täglich mit der Integration unseres Unternehmens in eine nachhaltige Wirtschaft.
              Der kontinuierliche Austausch mit unseren Kunden und Partnern sowie deren häufige Fragen nach Strategien zur Bewältigung aktueller klimabedingter Herausforderungen für die Wirtschaft haben uns dazu veranlasst, ein auf unserer Expertise basierendes Unternehmensberatungsprojekt zu entwickeln. So ist unser SRC-Projekt entstanden.
            </p>
            <p>
              SRC ist Ihr Partner für die Messung Ihrer ökologischen Auswirkungen und bietet Ihnen Lösungen für ein effizientes Management und die Verbesserung Ihrer Emissionen. Die Erreichung Ihrer Ziele wird in Übereinstimmung mit dem Klimaschutzgesetz geplant. Wir stützen unsere Strategie auf die betriebliche Effizienzsteigerung und Wachstumschancen für Ihr Unternehmen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;